import { isNodeKind } from "./shared/implement.js";
export const globalConfig = {};
export const mergeConfigs = (base, extensions) => {
    const result = { ...base };
    let k;
    for (k in extensions) {
        result[k] =
            isNodeKind(k) ?
                {
                    ...base[k],
                    ...extensions[k]
                }
                : extensions[k];
    }
    return result;
};
export const configure = (config) => Object.assign(globalConfig, mergeConfigs(globalConfig, config));
